/**
 * PATIENT_SETTINGS REQUESTS
 */

import { PATIENT_SETTINGS_URL } from '../apiUrl'
import Axios from './axiosSetup';

/**
 * Get user settings Request
 * @returns 
 */
export const GetUserSettings = (uid?: string) => {
  // Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return uid !== "" && uid !== undefined 
    ? Axios.get(`${PATIENT_SETTINGS_URL}/${uid}`) 
    : Axios.get(`${PATIENT_SETTINGS_URL}`) ;
}

/**
 * Get user settings Request
 * @returns 
 */
export const UpdateUserSettings = (uid?: string, formData?: any) => {
  // Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  return uid !== "" && uid !== undefined 
    ? Axios.put(`${PATIENT_SETTINGS_URL}/${uid}`, formData) 
    : Axios.put(`${PATIENT_SETTINGS_URL}`, formData) ;
}